// src/components/AuctionEnrollmentSection.jsx

import { Component } from 'react';
import '../../../../../../styles/components/auction-enrollment.scss';
import '../../../../../../styles/components/client-payment-summary.scss';

import {
  Users,
  CircleArrowDown,
  CircleArrowUp,
  Clock3,
  CircleCheckBig,
  ClipboardClock,
  BanknoteArrowDown,
  Banknote,
  Landmark,
  Building2,
  BanknoteArrowUp,
  Gavel,
  MoveRight,
} from 'lucide-react';
import { OMR } from '../../../../../common/icons';
import { PaymentTransaction } from './PaymentTransaction';
import { NavLink } from 'react-router-dom';
import CashFlowStatCard from '../CashFlowStatCard';
import DataTable from 'react-data-table-component';
import { tableStylesNew } from '../../../../../../styles/components/js/tableStyle';
import i18n from '../../../../../../i18n';

class AuctionPaymentSummary extends Component {
  constructor() {
    super();
    this.state = {
      showTransaction: false,
      transactionTitle: 'Tansactions',
    };
  }
  showPaymentHistory = (title) => {
    this.setState({ showTransaction: true, transactionTitle: title });
  };
  getPrimaryColumns = () => {
    const { search } = this.props;
    return [
      {
        name: i18n.t('sl'),
        selector: (row) => row.sl,
        // width: '80px',
        center: true,
        sortable: false,

        cell: (row, index) => <span className="sl-number">{index + 1}</span>,
      },
      {
        name: i18n.t('client_name'),
        selector: (row) => row.organization,
        // width: '130px',
        sortable: false,
        cell: (row) => <span className="remark-text">{row.organization.name}</span>,
      },
      {
        name: i18n.t('total_client_amount'),
        selector: (row) => row.amount,
        // width: '160px',
        right: true,
        sortable: false,
        cell: (row) => (
          <AmountCell
            amount={row.total_client_amount.amount}
            count={row.total_client_amount.auction_count}
            color="#1b8f9b"
          />
        ),
      },
      {
        name: i18n.t('client_amount_paid'),
        selector: (row) => row.paid_client_amount.amount,
        // width: '160px',
        right: true,
        sortable: false,
        cell: (row) => (
          <AmountCell
            amount={row.paid_client_amount.amount}
            count={row.paid_client_amount.auction_count}
            color="#10b981"
          />
        ),
      },
      {
        name: i18n.t('client_amount_pending'),
        selector: (row) => row.pending_client_amount.amount,
        // width: '160px',
        right: true,
        sortable: false,
        cell: (row) => (
          <AmountCell
            amount={row.pending_client_amount.amount}
            count={row.pending_client_amount.auction_count}
            color="#ef4444"
          />
        ),
      },
      {
        name: i18n.t('action'),
        selector: (row) => row.organization.id,
        right: true,

        cell: (row) => (
          <NavLink
            to={{
              pathname: '/cash-flow/auction-payment/client/details',

              search: new URLSearchParams(
                Object.fromEntries(
                  Object.entries({
                    startDate: search?.startDate,
                    endDate: search?.endDate,
                    bidder: search?.bidder,
                    group: search?.group,

                    // CLIENT ID FROM ROW
                    client: row?.organization?.id,

                    status: 'client_pending',
                  }).filter(([_, v]) => v !== null && v !== '' && v !== undefined)
                )
              ).toString(),
            }}
            className="details-link"
          >
            {i18n.t('details')}
            <span className="arrow">
              <MoveRight strokeWidth={1} />
            </span>
          </NavLink>
        ),
      },
    ];
  };
  render() {
    const { showTransaction, transactionTitle } = this.state;
    const { data, search, clientPayOutSummary } = this.props;

    const clientPayOutData = clientPayOutSummary?.data || [];
    const clientPayOutMeta = clientPayOutSummary?.meta || null;

    return (
      <section className="auction-enrollment">
        {/* Header */}
        <div className="ae-header">
          <div className="ae-header__left">
            <div className="ae-main-icon">
              <Gavel size={20} strokeWidth={2.2} />
            </div>

            <div>
              <h2 className="ae-title">{i18n.t('auction_payment_summary')}</h2>

              <p className="ae-subtitle">
                {i18n.t('final_bid_payments_vat_service_charge_distribution')}
              </p>
            </div>
          </div>
        </div>

        {/* Cards */}
        <div className="ae-grid">
          <CashFlowStatCard
            icon={<Gavel size={24} strokeWidth={2} />}
            title={i18n.t('total_bidder_auction_amount')}
            value={data?.total_auction_amount?.amount || 0}
            subtitle={`${data?.total_auction_amount?.count || 0} ${i18n.t('auctions')}`}
            iconClass="blue"
            valueClass="blue-text"
            color="#1794ae"
          />

          <CashFlowStatCard
            icon={<BanknoteArrowDown size={24} strokeWidth={2} />}
            title={i18n.t('total_bidder_auction_amount_in')}
            value={data?.total_auction_amount_in?.amount || 0}
            subtitle={`${data?.total_auction_amount_in?.count || 0} ${i18n.t('auctions')}`}
            iconClass="green"
            valueClass="green-text"
            color="#32a852"
          />

          <CashFlowStatCard
            icon={<BanknoteArrowUp size={24} strokeWidth={2} />}
            title={i18n.t('total_client_amount_out')}
            value={data?.total_auction_amount_out?.amount || 0}
            subtitle={`${data?.total_auction_amount_out?.count || 0} ${i18n.t('auctions')}`}
            iconClass="red"
            valueClass="red-text"
            color="#dc5b4d"
          />
        </div>

        {/* Cash Flow IN  */}

        <div className="cashflow in">
          {/* Header */}
          <div className="cf-header">
            <div className="cf-header__left">
              <div className="cf-main-icon green">
                <CircleArrowDown size={20} strokeWidth={1.8} />
              </div>

              <div>
                <h2 className="cf-title">{i18n.t('cash_flow_in')}</h2>

                <p className="cf-subtitle">{i18n.t('total_auction_payment')}</p>
              </div>
            </div>
          </div>
          <div className="cf-details">
            {/* Refunded Section */}
            <div className="cf-section">
              <div className="cf-section__title green">
                <CircleCheckBig size={16} />
                <span>{i18n.t('completed_payments')}</span>
              </div>

              <div className="cf-card-grid">
                {/* Card 1 */}
                <NavLink
                  to={{
                    pathname: '/cash-flow/auction-payment/bidder/details',
                    search: new URLSearchParams(
                      Object.fromEntries(
                        Object.entries({
                          startDate: search?.startDate,
                          endDate: search?.endDate,
                          bidder: search?.bidder,
                          client: search?.client,
                          group: search?.group,
                          status: 'bidder_completed',
                        }).filter(([_, v]) => v !== null && v !== '' && v !== undefined)
                      )
                    ).toString(),
                  }}
                  className="cf-stat-card"
                >
                  <div className="cf-stat-card__top">
                    <div className="cf-stat-card__icon amount">
                      <Banknote size={18} />
                    </div>
                  </div>
                  <h4 className="cf-stat-card__title">
                    {i18n.t('bidder_auction_payment_received')}
                  </h4>
                  <h3 className="cf-stat-card__value green">
                    {data?.total_auction_amount_in?.amount || 0} <OMR size={12} color={'#16a34a'} />
                  </h3>

                  <p className="cf-stat-card__label">
                    {data?.total_auction_amount_in?.count || 0} {i18n.t('auctions')}
                  </p>
                </NavLink>
              </div>
            </div>

            {/* Pending Section */}
            <div className="cf-section">
              <div className="cf-section__title pending">
                {i18n.t('pending_payments')}
                <Clock3 size={18} />
                <span></span>
              </div>

              <div className="cf-card-grid">
                {/* Card 1 */}
                <NavLink
                  to={{
                    pathname: '/cash-flow/auction-payment/bidder/details',
                    search: new URLSearchParams(
                      Object.fromEntries(
                        Object.entries({
                          startDate: search?.startDate,
                          endDate: search?.endDate,
                          bidder: search?.bidder,
                          client: search?.client,
                          group: search?.group,
                          status: 'bidder_pending',
                        }).filter(([_, v]) => v !== null && v !== '' && v !== undefined)
                      )
                    ).toString(),
                  }}
                  className="cf-stat-card pending"
                >
                  <div className="cf-stat-card__top">
                    <div className="cf-stat-card__icon amount pending">
                      <ClipboardClock size={18} />
                    </div>
                  </div>
                  <h4 className="cf-stat-card__title">
                    {i18n.t('bidder_auction_payment_pending')}
                  </h4>
                  <h3 className="cf-stat-card__value pending">
                    {data?.total_auction_amount_in_pending?.amount || 0}{' '}
                    <OMR size={12} color={'#d97706'} />
                  </h3>

                  <p className="cf-stat-card__label">
                    {data?.total_auction_amount_in_pending?.count || 0} {i18n.t('auctions')}
                  </p>
                </NavLink>
              </div>
            </div>
          </div>
        </div>

        {/* Cash Flow OUT  */}

        <div className="cashflow out">
          {/* Header */}
          <div className="cf-header">
            <div className="cf-header__left">
              <div className="cf-main-icon red">
                <CircleArrowUp size={20} strokeWidth={1.8} />
              </div>

              <div>
                <h2 className="cf-title red">{i18n.t('cash_flow_out')}</h2>

                <p className="cf-subtitle">{i18n.t('payments_made_to_client')}</p>
              </div>
            </div>
          </div>
          <div className="cf-details column">
            {/* Completed Distributions Section */}
            <div className="cf-section-2">
              <div className="cf-section__title green">
                <CircleCheckBig size={16} />
                <span>{i18n.t('completed_client_payments_vat_transfers')}</span>
              </div>

              <div className="cf-card-grid out">
                {/* Card 1 */}
                <NavLink
                  to={{
                    pathname: '/cash-flow/auction-payment/client/details',
                    search: new URLSearchParams(
                      Object.fromEntries(
                        Object.entries({
                          startDate: search?.startDate,
                          endDate: search?.endDate,
                          bidder: search?.bidder,
                          client: search?.client,
                          group: search?.group,
                          status: 'client_completed',
                        }).filter(([_, v]) => v !== null && v !== '' && v !== undefined)
                      )
                    ).toString(),
                  }}
                  className="cf-stat-card"
                >
                  <div className="cf-stat-card__top">
                    <div className="cf-stat-card__icon users">
                      <Users size={18} />
                    </div>
                  </div>
                  <h4 className="cf-stat-card__title">{i18n.t('client_amount_paid')}</h4>
                  <h3 className="cf-stat-card__value green">
                    {data?.total_auction_amount_out?.client_amount || 0}{' '}
                    <OMR size={12} color={'#16a34a'} />
                  </h3>

                  <p className="cf-stat-card__label">
                    {i18n.t('final_bid_amounts_vat_to_clients')}
                  </p>
                </NavLink>

                {/* Card 2 */}
                <NavLink
                  to={{
                    pathname: '/cash-flow/auction-payment/client/details',
                    search: new URLSearchParams(
                      Object.fromEntries(
                        Object.entries({
                          startDate: search?.startDate,
                          endDate: search?.endDate,
                          bidder: search?.bidder,
                          client: search?.client,
                          group: search?.group,
                          status: 'client_completed',
                        }).filter(([_, v]) => v !== null && v !== '' && v !== undefined)
                      )
                    ).toString(),
                  }}
                  className="cf-stat-card"
                >
                  <div className="cf-stat-card__top">
                    <div className="cf-stat-card__icon amount">
                      <Landmark size={18} />
                    </div>
                  </div>
                  <h4 className="cf-stat-card__title"> {i18n.t('vat_transferred')}</h4>
                  <h3 className="cf-stat-card__value green">
                    {data?.total_auction_amount_out?.service_charge_vat || 0}
                    <OMR size={12} color={'#16a34a'} />
                  </h3>

                  <p className="cf-stat-card__label">
                    {i18n.t('service_charge_vat_to_vat_account')}
                  </p>
                </NavLink>

                {/* Card 3 */}
                <NavLink
                  to={{
                    pathname: '/cash-flow/auction-payment/client/details',
                    search: new URLSearchParams(
                      Object.fromEntries(
                        Object.entries({
                          startDate: search?.startDate,
                          endDate: search?.endDate,
                          bidder: search?.bidder,
                          client: search?.client,
                          group: search?.group,
                          status: 'client_completed',
                        }).filter(([_, v]) => v !== null && v !== '' && v !== undefined)
                      )
                    ).toString(),
                  }}
                  className="cf-stat-card"
                >
                  <div className="cf-stat-card__top">
                    <div className="cf-stat-card__icon amount">
                      <Building2 size={18} />
                    </div>
                  </div>
                  <h4 className="cf-stat-card__title">{i18n.t('profit')}</h4>
                  <h3 className="cf-stat-card__value green">
                    {data?.total_auction_amount_out?.service_charge || 0}{' '}
                    <OMR size={12} color={'#16a34a'} />
                  </h3>

                  <p className="cf-stat-card__label">{i18n.t('auction_service_charge_revenue')}</p>
                </NavLink>
              </div>
            </div>

            {/* Refund Pending Section */}
            <div className="cf-section-2">
              <div className="cf-section__title pending">
                <Clock3 size={18} />
                <span>{i18n.t('pending_client_due_vat_transfers')}</span>
              </div>

              <div className="cf-card-grid">
                {/* Card 1 */}
                <NavLink
                  to={{
                    pathname: '/cash-flow/auction-payment/client/details',
                    search: new URLSearchParams(
                      Object.fromEntries(
                        Object.entries({
                          startDate: search?.startDate,
                          endDate: search?.endDate,
                          bidder: search?.bidder,
                          client: search?.client,
                          group: search?.group,
                          status: 'client_pending',
                        }).filter(([_, v]) => v !== null && v !== '' && v !== undefined)
                      )
                    ).toString(),
                  }}
                  className="cf-stat-card pending"
                >
                  <div className="cf-stat-card__top">
                    <div className="cf-stat-card__icon users pending">
                      <Users size={18} />
                    </div>
                  </div>
                  <h4 className="cf-stat-card__title">{i18n.t('pending_client_due')}</h4>
                  <h3 className="cf-stat-card__value pending">
                    {data?.total_auction_amount_out_pending?.client_amount || 0}
                    <OMR size={12} color={'#d97706'} />
                  </h3>

                  <p className="cf-stat-card__label">
                    {i18n.t('final_bid_amounts_vat_to_clients')}
                  </p>
                </NavLink>

                {/* Card 2 */}
                <NavLink
                  to={{
                    pathname: '/cash-flow/auction-payment/client/details',
                    search: new URLSearchParams(
                      Object.fromEntries(
                        Object.entries({
                          startDate: search?.startDate,
                          endDate: search?.endDate,
                          bidder: search?.bidder,
                          client: search?.client,
                          group: search?.group,
                          status: 'client_pending',
                        }).filter(([_, v]) => v !== null && v !== '' && v !== undefined)
                      )
                    ).toString(),
                  }}
                  className="cf-stat-card pending"
                >
                  <div className="cf-stat-card__top">
                    <div className="cf-stat-card__icon amount pending">
                      <Landmark size={18} />
                    </div>
                  </div>
                  <h4 className="cf-stat-card__title">{i18n.t('vat_pending')}</h4>
                  <h3 className="cf-stat-card__value pending">
                    {data?.total_auction_amount_out_pending?.service_charge_vat || 0}{' '}
                    <OMR size={12} color={'#d97706'} />
                  </h3>

                  <p className="cf-stat-card__label">
                    {i18n.t('service_charge_vat_to_vat_account')}
                  </p>
                </NavLink>

                {/* Card 3 */}
                <NavLink
                  to={{
                    pathname: '/cash-flow/auction-payment/client/details',
                    search: new URLSearchParams(
                      Object.fromEntries(
                        Object.entries({
                          startDate: search?.startDate,
                          endDate: search?.endDate,
                          bidder: search?.bidder,
                          client: search?.client,
                          group: search?.group,
                          status: 'client_completed',
                        }).filter(([_, v]) => v !== null && v !== '' && v !== undefined)
                      )
                    ).toString(),
                  }}
                  className="cf-stat-card pending"
                >
                  <div className="cf-stat-card__top">
                    <div className="cf-stat-card__icon amount pending">
                      <Building2 size={18} />
                    </div>
                  </div>
                  <h4 className="cf-stat-card__title">{i18n.t('profit')}</h4>
                  <h3 className="cf-stat-card__value pending">
                    {data?.total_auction_amount_out_pending?.service_charge || 0}
                    <OMR size={12} color={'#d97706'} />
                  </h3>

                  <p className="cf-stat-card__label"> {i18n.t('auction_service_charge_revenue')}</p>
                </NavLink>
              </div>

              <div className="payment-summary-container">
                <div className="summary-header">
                  <div className="psm-header-title">
                    <h1>{i18n.t('outstanding_client_due')}</h1>
                    <p className="header-subtitle-w3">
                      {i18n.t('detailed_client_payment_pending_summary')}
                    </p>
                  </div>
                </div>

                {/* DataTable Component */}
                <div className="payment-table-wrapper">
                  <DataTable
                    responsive={true}
                    columns={this.getPrimaryColumns()}
                    data={clientPayOutData}
                    customStyles={tableStylesNew}
                    highlightOnHover
                  />
                </div>

                {/* Summary Footer */}
                <div className="summary-footer">
                  <div className="footer-section-w3 ">
                    <div className="section-label">{i18n.t('client_invoice')}</div>
                    <div className="amount-display"></div>
                  </div>

                  <div className="footer-section-w3 total-section">
                    <div className="section-label">{i18n.t('total_invoice')}</div>
                    <div className="amount-display">
                      {clientPayOutMeta?.totals?.total_client_amount || 0}
                    </div>
                  </div>

                  <div className="footer-section-w3 vat-section">
                    <div className="section-label">{i18n.t('total_amount_paid')}</div>
                    <div className="amount-display">
                      {clientPayOutMeta?.totals?.paid_client_amount || 0}
                    </div>
                  </div>

                  <div className="footer-section-w3 balance-section">
                    <div className="section-label">{i18n.t('balance_to_pay')}</div>
                    <div className="amount-display highlight">
                      {clientPayOutMeta?.totals?.pending_client_amount || 0}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <PaymentTransaction
          show={showTransaction}
          title={transactionTitle}
          onClose={() => this.setState({ showTransaction: false, transactionTitle: 'Tansactions' })}
        />
      </section>
    );
  }
}

export default AuctionPaymentSummary;
const AmountCell = ({ amount, count, color = '#1b8f9b' }) => {
  return (
    <div className="amount-cell">
      <div className="d-flex flex-column align-items-end">
        {/* amount + OMR */}
        <div className="d-flex align-items-center gap-1">
          <span className="amount-value" style={{ color }}>
            {amount}
          </span>
          <OMR size={10} color={color} />
        </div>

        {/* auction count */}
        <small>
          <span className="auction-count">{count}</span>{' '}
          <span className="auction-label">auctions</span>
        </small>
      </div>
    </div>
  );
};
